'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright, SvgChevronrightDouble, SvgTruckFill } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AuthQueryOptions } from '@/api';
interface DeliveryTrackingModalContentProps {
  orderId: string;
  deliveryId: string;
  trackingProvider?: 'GOODSFLOW' | 'LOGIS_TRACKING';
}
export const DeliveryTrackingModalContent = t0 => {
  const $ = _c(12);
  const {
    orderId,
    deliveryId,
    trackingProvider
  } = t0;
  let t1;
  if ($[0] !== deliveryId || $[1] !== orderId || $[2] !== trackingProvider) {
    t1 = trackingProvider === "LOGIS_TRACKING" ? AuthQueryOptions["get:/wello/v3/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking"]({
      path: {
        orderId,
        deliveryId
      }
    }) : AuthQueryOptions["get:/wello/v2/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking"]({
      path: {
        orderId,
        deliveryId
      }
    });
    $[0] = deliveryId;
    $[1] = orderId;
    $[2] = trackingProvider;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const queryOption = t1;
  let t2;
  if ($[4] !== queryOption) {
    t2 = {
      ...queryOption,
      select: _temp,
      retry: 1
    };
    $[4] = queryOption;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: tracking,
    isLoading
  } = useQuery(t2);
  if (isLoading) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="px-16 py-40 text-center font-400 text-Gray-600 typo-body4">배송 정보를 불러오는 중...</div>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (!tracking) {
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = cn("mx-16 rounded-xsmall bg-Gray-25 px-12 py-16 text-center font-400 text-Gray-600 typo-body4", "mobile-tablet:py-20 mobile-tablet:typo-caption1");
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className={t3}>판매자가 택배기사님께 상품을 전달하면<br />배송조회가 가능해져요. 조금만 기다려주세요!</div>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t3;
  if ($[9] !== tracking.details || $[10] !== tracking.lastStatus) {
    t3 = <div className="py-20">{tracking.details && tracking.details.length > 0 ? <><div className={cn("rounded-small bg-Gray-50 p-16", "mobile-tablet:rounded-none")}><div className="flex items-center justify-center gap-12"><SvgTruckFill className="size-20 text-B-200" /><div className={cn("flex items-center justify-center gap-12 font-600 text-Gray-600 typo-body4", "mobile-tablet:gap-4 mobile-tablet:typo-caption1")}><span className={cn("text-center", {
                "text-B-500": tracking.lastStatus === "PICKUP"
              })}>상품발송</span><SvgChevronright className={cn("size-16 text-Gray-400", "mobile-tablet:size-12")} /><span className={cn("text-center", {
                "text-B-500": tracking.lastStatus === "IN_TRANSIT"
              })}>택배사 도착</span><SvgChevronrightDouble className={cn("size-16 text-Gray-400", "mobile-tablet:size-12")} /><span className={cn("text-center", {
                "text-B-500": tracking.lastStatus === "IN_TRANSIT"
              })}>배송중</span><SvgChevronright className={cn("size-16 text-Gray-400", "mobile-tablet:size-12")} /><span className={cn("text-center", {
                "text-B-500": tracking.lastStatus === "COMPLETED"
              })}>배송완료</span></div></div></div><div className={cn("mobile-tablet:pt-16")}><div className={cn("grid grid-cols-3 border-b border-Gray-200 py-20", "mobile-tablet:py-10")}><span className={cn("text-center font-600 text-Gray-900 typo-body4", "mobile-tablet:typo-caption1")}>처리 일시</span><span className={cn("text-center font-600 text-Gray-900 typo-body4", "mobile-tablet:typo-caption1")}>현재 위치</span><span className={cn("text-center font-600 text-Gray-900 typo-body4", "mobile-tablet:typo-caption1")}>상태</span></div>{tracking.details.map(_temp2)}</div></> : <div className={cn("mx-16 rounded-xsmall bg-Gray-25 px-12 py-16 text-center font-400 text-Gray-600 typo-body4", "mobile-tablet:py-20 mobile-tablet:typo-caption1")}>판매자가 택배기사님께 상품을 전달하면<br />배송조회가 가능해져요. 조금만 기다려주세요!</div>}</div>;
    $[9] = tracking.details;
    $[10] = tracking.lastStatus;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp2(item, index) {
  return <div key={index} className={cn("grid grid-cols-3 items-center border-b border-Gray-100")}><span className={cn("whitespace-pre-line text-center font-400 text-Gray-900 typo-body4", "mobile-tablet:whitespace-normal mobile-tablet:typo-caption2")}>{item.statusDateTime ? dayjs(item.statusDateTime).format("YYYY-MM-DD\nHH:mm:ss") : "-"}</span><span className={cn("py-20 text-center font-400 text-Gray-900 typo-body4", "mobile-tablet:py-10 mobile-tablet:typo-caption2")}>{item.location || "-"}</span><span className={cn("py-20 text-center font-400 typo-body4", "mobile-tablet:py-10 mobile-tablet:typo-caption2", {
      "text-B-500": item.statusName?.includes("\uC644\uB8CC"),
      "text-Gray-900": !item.statusName?.includes("\uC644\uB8CC")
    })}>{item.statusName || "-"}</span></div>;
}